import React from 'react';
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Grid,
  Alert,
  Button
} from '@mui/material';
import { AdminPanelSettings, People, Assessment } from '@mui/icons-material';

const AdminPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <AdminPanelSettings />
          Admin Dashboard
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Administrative tools and system management
        </Typography>
      </Box>

      <Alert severity="warning" sx={{ mb: 3 }}>
        Admin features are being migrated to Material-UI. Full functionality will be restored shortly.
      </Alert>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <People />
                User Management
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Manage user accounts and permissions
              </Typography>
              <Button variant="outlined" disabled>
                Manage Users
              </Button>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Assessment />
                System Analytics
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                View system metrics and usage statistics
              </Typography>
              <Button variant="outlined" disabled>
                View Analytics
              </Button>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                System Status
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Monitor system health and performance
              </Typography>
              <Button variant="outlined" disabled>
                View Status
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Administrative Actions
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Administrative tools and actions will be available here once the migration is complete
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AdminPage;